module.exports = __webpack_public_path__ + "media/images/savor-arrow-6d9067ef8bcd855f5305689a51d7d8b7.png";